import { render, staticRenderFns } from "./PaginationAndTableInfo.vue?vue&type=template&id=6d0f2228"
import script from "./PaginationAndTableInfo.vue?vue&type=script&lang=js"
export * from "./PaginationAndTableInfo.vue?vue&type=script&lang=js"
import style0 from "./PaginationAndTableInfo.vue?vue&type=style&index=0&id=6d0f2228&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports